<template>
	<el-dialog :visible.sync="visible" class="elDialog" width="845px" :title="(!dataForm.id ? $t('add') : $t('update')) + '开票项目'" :close-on-click-modal="false" :close-on-press-escape="false">
		<el-form :model="dataForm" style="padding-right: 40px;" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'">
			<el-row>
				<el-col :span="24">
					<el-form-item label="服务类型" prop="ticketCode">
						<div style="min-width: 505px;background: #FCFCFC;border: 1px solid #C9C9C9;border-radius: 4px;border-bottom:0px;">
							<div @click="isshow" style="height: 40px;line-height: 40px;padding:0px 10px;border-bottom: 1px solid #C9C9C9;position: relative;" icon="el-icon-arrow-down">
							{{dataForm.serverName!=''?dataForm.serverName:'服务类型'}}
							<i class="el-icon-arrow-up" v-if="notshow" style="display: block;position:absolute;right: 10px;top: 40%;"></i>
							<i class="el-icon-arrow-down" v-else style="display: block;position:absolute;right: 10px;top: 40%;"></i>
							</div>
							<el-tree ref="tree" highlight-current node-key="id" style="background: #FCFCFC;border-bottom: 1px solid #C9C9C9;" :default-expanded-keys="defaultkey" v-show="notshow" :data="options" :props="{label:'name',children:'children'}" :accordion="true" @node-click="handleNodeClick"></el-tree>
						</div>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="开票项目" prop="ticketProject">
						<el-input v-model="dataForm.ticketProject" placeholder="开票项目"></el-input>
					</el-form-item>
				</el-col>
			<el-col :span="12">
				<el-form-item label="税源地" prop="bodyId">
					<el-select class="select-body" v-model="dataForm.bodyId" filterable placeholder="请选择" style="width:100%;" @change="handleChange">
						<el-option
							v-for="item in bodyInfo"
							:key="item.id"
							:label="item.abbreviation"
							:value="item.id"
							class="option-body">
						</el-option>
					</el-select>
				</el-form-item>
			</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="状态" prop="isEnable">
						<el-checkbox v-model="dataForm.checked">停用</el-checkbox>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<template slot="footer">
			<el-button type="primary" @click="dataFormSubmitHandle()" :loading="loadingbut">{{ $t('confirm') }}</el-button>
			<el-button @click="visible = false">{{ $t('cancel') }}</el-button>
		</template>
	</el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import axios from 'axios'
export default {
  data () {
    return {
      bodyInfo:[],//税源地列表
      visible: false,
	  loadingbut: false,
	  options: [],
	  datatwo: [],
	  datathree: [],
	  notshow: false,
	  defaultkey: [],
	  olddata: [],
      dataForm: {
        id: '',
        bodyId:'',
        taxType: '',
        ticketCode: '',
        serverType: '',
        serverContent: '',
        ticketProject: '',
        isEnable: 1,
        checked: false,
        serverName: '',
        serverLabel: ''
      }
    }
  },
  computed: {
		dataRule () {
			return {
				ticketProject: [
					{ required: true, message: this.$t('validate.required'), trigger: 'blur' }
				],
				bodyId: [
					{ required: true, message: this.$t('validate.required'), trigger: 'blur' }
				]
			}
		}
  },
  created () {
    
  },
  methods: {
	// 切换税源地
	handleChange(e){
		console.log(e)
		console.log(this.bodyInfo.filter((item) => item.id == e)[0])
		this.dataForm.abbreviation = '';
		this.dataForm.bodyName = '';
	},
	isshow () {
		this.$nextTick(() => {
			this.notshow = !this.notshow
			this.defaultkey = []
			this.getDefalutdata(this.dataForm.ticketCode)
		})
	},
	getTreeData (data, level = 1, parentid = 0) {
		for (var i = 0; i < data.length; i++) {
			let info = []
			info.level = level
			info.code = data[i].code
			info.parentid = parentid
			data[i].id = data[i].code.toString()
			data[i].key = data[i].code.toString()
			this.olddata.push(info)
			if (data[i].children.length < 1) {
				// children若为空数组，则将children设为undefined
				data[i].children = undefined
			} else {
				// children若不为空数组，则继续 递归调用 本方法
				this.getTreeData(data[i].children, level + 1, data[i].code)
			}
		}
		return data
	},
	handleNodeClick (e) {
		if (e.children == undefined) {
			this.dataForm.ticketCode = e.code
			this.dataForm.serverName = e.name
			this.dataForm.serverLabel = e.label
			this.notshow = !this.notshow
		}
	},
    init () {
		// 获取税源地列表
		this.$http.get(`/sys/plat/body/page?order=&orderField=&page=1&limit=1000&sydEdit=1`).then(({ data: res }) => {
			this.bodyInfo = res.data.list;
		})
		this.visible = true
		this.olddata = []
		this.notshow = false
		this.$nextTick(() => {
		this.dataForm.ticketCode = ''
		this.dataForm.serverName = ''
		this.dataForm.serverLabel = ''
			this.$refs['dataForm'].resetFields()
			if (this.dataForm.id) {
				this.getInfo()
			} else {
				let that = this
				this.$axios({
					method: 'post',
					url: 'https://ctxzuulqy.cailian.net/ctx-setting/v1/SettingTaxClass/queryAll',
					data: {}
				}).then(function (response) {
					// that.options = response.data.value;
					let data = response.data.value
					for (let j = 0; j < data.length; j++) {
						if (data[j].name == '未发生销售行为的不征税项目') {
						data.splice(j, 1)
						break
					}
				}
					that.options = that.getTreeData(data)
				})
				.catch(function (error) {
					console.log(error)
				})
				}
		})
    },
    getDefalutdata (code) {
		for (let i = 0; i < this.olddata.length; i++) {
			if (this.olddata[i].code == code) {
				this.defaultkey.unshift(this.olddata[i].code.toString())
				if (this.olddata[i].level != 1) {
					this.getDefalutdata(this.olddata[i].parentid)
				}
			}
		}
    },
    // 获取信息
    getInfo () {
		this.$http.get(`/sys/plat/ticketPro/${this.dataForm.id}`).then(({ data: res }) => {
			if (res.code !== 0) {
				return this.$message.error(res.msg)
			}
			this.dataForm = {
				...this.dataForm,
				...res.data
			}
			let that = this
			this.$axios({
				method: 'post',
				url: 'https://ctxzuulqy.cailian.net/ctx-setting/v1/SettingTaxClass/queryAll',
				data: {}
			}).then(function (response) {
				// that.options = response.data.value;
				let data = response.data.value
				for (let j = 0; j < data.length; j++) {
					if (data[j].name == '未发生销售行为的不征税项目') {
						data.splice(j, 1)
						break
					}
				}
				that.options = that.getTreeData(data)
			}).catch(function (error) {})
			this.dataForm.checked = this.dataForm.isEnable == 0
		}).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
		this.$refs['dataForm'].validate((valid) => {
			if (!valid) {
				return false
			}
			if (this.dataForm.ticketCode == '') {
				return this.$message.error('请选择服务类型')
			}
			this.loadingbut = true
			this.dataForm.isEnable = this.dataForm.checked == true ? 0 : 1
			this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/plat/ticketPro/', this.dataForm).then(({ data: res }) => {
			this.loadingbut = false
			if (res.code !== 0) {
				return this.$message.error(res.msg)
			}
			this.$message({
				message: this.$t('prompt.success'),
				type: 'success',
				duration: 500,
				onClose: () => {
				this.visible = false
				this.$emit('refreshDataList')
				}
			})
			}).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style scoped="scoped">
	.elDialog >>> .el-dialog__header{
		padding: 23px 39px;
		border-bottom: 1px solid #D1D1D1;
	}
	.elDialog >>> .el-dialog__body{
		border-bottom: 1px solid #D1D1D1;
	}
</style>
